import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Button from './button.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['container', 'button', 'input'];
var baseStyleButton = function baseStyleButton(props) {
  var c = props.colorScheme;
  return _objectSpread(_objectSpread({}, Button.baseStyle), {}, {
    boxShadow: 'none',
    border: 0,
    bg: "gray.100",
    borderRadius: 'full',
    color: "".concat(c, ".400"),
    boxSize: 7,
    flexShrink: 0,
    p: 0,
    _disabled: _objectSpread(_objectSpread({}, Button.baseStyle({})._disabled), {}, {
      bg: "gray.100",
      color: "".concat(c, ".400"),
      opacity: 0.5,
      _hover: {
        bg: "gray.100"
      }
    }),
    _hover: {
      bg: "gray.200"
    },
    _active: {
      bg: "gray.100"
    }
  });
};
var baseStyleInput = {
  fontWeight: 'semibold',
  textAlign: 'center',
  mx: 4,
  cursor: 'default'
};
var baseStyle = function baseStyle(props) {
  return {
    container: {},
    button: baseStyleButton(props),
    input: baseStyleInput
  };
};
var defaultProps = {
  colorScheme: 'blue'
};
var Stepper = {
  parts: parts,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { Stepper as default };